import React, { useRef, useMemo, useState, useEffect } from 'react';
import { apiHolder } from 'api';
import styles from './emojiTip.module.scss';
import EmojiTipImg from '@/images/emojitip.png';
import ReactDOM from 'react-dom';
import { apiHolder as api } from 'api';
const systemApi = api.api.getSystemApi();
const inEdm = systemApi.inEdm();
const { isMac } = apiHolder.env;
const storeApi = apiHolder.api.getDataStoreApi();
let calcPosTimer = null;
const EmojiTip = props => {
    const { setCapturescreenTipVisible } = props;
    const [position, setPosition] = useState();
    const rangestartRef = useRef(null);
    const rangeendRef = useRef(null);
    const range = useMemo(() => {
        if (rangestartRef.current && rangeendRef.current) {
            const range = typeof Range === 'function' ? new Range() : document.createRange();
            range.setStartBefore(rangestartRef.current);
            range.setEndAfter(rangeendRef.current);
            return range;
        }
        return null;
    }, [rangestartRef.current, rangeendRef.current]);
    const handleNext = () => {
        setCapturescreenTipVisible(false);
        storeApi.putSync('lx_write_capturescreen1', 'true', { noneUserRelated: true });
    };
    const calcPos = () => {
        if (!range) {
            return;
        }
        const triggerRefDom = Array.from(range.commonAncestorContainer.childNodes).slice(range.startOffset + 1, range.endOffset - 1);
        if (triggerRefDom) {
            calcPosTimer = setTimeout(() => {
                let minx = 100000;
                let miny = 100000;
                let maxx = 0;
                let maxy = 0;
                triggerRefDom.forEach((node) => {
                    const { x, y, width, height } = node.getBoundingClientRect();
                    if (width > 0 && height > 0) {
                        if (x < minx) {
                            minx = x;
                        }
                        if (y < miny) {
                            miny = y;
                        }
                        if (x + width > maxx) {
                            maxx = x + width;
                        }
                        if (y + height > maxy) {
                            maxy = y + height;
                        }
                    }
                });
                if (minx !== 100000) {
                    let width = maxx - minx;
                    let height = maxy - miny;
                    setPosition({
                        x: minx,
                        y: miny,
                        height: height,
                        width: width,
                    });
                }
            }, 500);
        }
        else {
            setPosition(null);
        }
    };
    useEffect(() => calcPos(), [range]);
    const Footer = () => {
        return (React.createElement("div", { className: styles.footer },
            React.createElement("button", { className: styles.butt, onClick: handleNext }, "\u77E5\u9053\u4E86")));
    };
    const GuideContent = () => {
        return (React.createElement(React.Fragment, null, position && (React.createElement("div", { className: styles.maskWrapper },
            React.createElement("div", { className: styles.archerWrapper, style: { left: position.x, height: position.height, top: position.y, width: position.width } },
                React.createElement("div", { className: styles.guideBobble },
                    React.createElement("p", { className: styles.title },
                        "\u5199\u4FE1\u65B0\u589E \u622A\u56FE (",
                        isMac ? '⌘ Shift A' : 'Alt A',
                        ") \u529F\u80FD"),
                    React.createElement(Footer, null)))))));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { ref: rangestartRef, style: { display: 'none' } }),
        React.createElement("p", { className: styles.emojiTipImg, style: { top: inEdm ? '40px' : '-41px' } },
            React.createElement("img", { src: EmojiTipImg })),
        React.createElement("span", { ref: rangeendRef, style: { display: 'none' } }),
        (document === null || document === void 0 ? void 0 : document.body) ? ReactDOM.createPortal(React.createElement(GuideContent, null), document.body) : React.createElement(GuideContent, null)));
};
export default EmojiTip;
